import React from "react";
import { Card, Row, Col } from "antd";

const conversionEjemplo = [
  { key: "1", provUnidad: "Ltr", provCantidad: 4, invUnidad: "gal", invCantidad: 1, conversion: 0.25 },
  { key: "2", provUnidad: "gal", provCantidad: 1, invUnidad: "ltr", invCantidad: 4, conversion: 4.0 },
  { key: "3", provUnidad: "mtr", provCantidad: 44.8, invUnidad: "pza", invCantidad: 7, conversion: 0.1563 },
  { key: "4", provUnidad: "pza", provCantidad: 1, invUnidad: "mtr", invCantidad: 6.1, conversion: 6.1 },
  { key: "5", provUnidad: "ton", provCantidad: 1, invUnidad: "kg", invCantidad: 1000, conversion: 1000.0 },
  { key: "6", provUnidad: "kg", provCantidad: 1000, invUnidad: "ton", invCantidad: 1, conversion: 0.001 },
  { key: "7", provUnidad: "pt", provCantidad: 36, invUnidad: "pza", invCantidad: 4, conversion: 0.1111 },
  { key: "8", provUnidad: "caja", provCantidad: 1, invUnidad: "pza", invCantidad: 24, conversion: 24.0 },
  { key: "9", provUnidad: "pza", provCantidad: 24, invUnidad: "caja", invCantidad: 1, conversion: 0.0417 },
];

const TablaEjemplosConversion = () => {
  const headerMain = {
    fontWeight: 600,
    textAlign: "center",
    padding: "10px 4px",
    background: "#e6f7ff",
    borderBottom: "2px solid #91d5ff",
    color: "#0050b3",
    fontSize: 13,
  };

  const headerSub = {
    fontWeight: 600,
    textAlign: "center",
    padding: "6px 4px",
    background: "#f0f5ff",
    borderBottom: "1px solid #d6e4ff",
    color: "#3a5fcd",
    fontSize: 12,
  };

  const cell = {
    textAlign: "center",
    padding: "8px 4px",
    borderBottom: "1px solid #f0f0f0",
    fontSize: 12,
    color: "#595959",
  };

  const cellConversion = {
    ...cell,
    fontWeight: 600,
    backgroundColor: "#fafafa",
    color: "#262626",
  };

  return (
    <Card
      size="small"
      style={{
        marginTop: 16,
        marginBottom: 16,
        backgroundColor: "white",
        borderRadius: 6,
        border: "1px solid #d9d9d9",
        boxShadow: "0px 1px 2px rgba(0,0,0,0.05)",
      }}
      bodyStyle={{ padding: 0 }}
    >
      <div style={{ padding: "10px 14px", borderBottom: "1px solid #d9d9d9", background: "#fafafa" }}>
        <span style={{ color: "#1890ff", fontWeight: 600 }}>Ejemplos de conversión</span>
      </div>

      <Row style={{ borderBottom: "2px solid #d9d9d9" }}>
        <Col span={9} style={{ ...headerMain, borderRight: "1px solid #d9d9d9" }}>Proveedor</Col>
        <Col span={9} style={{ ...headerMain, borderRight: "1px solid #d9d9d9" }}>Inventario</Col>
        <Col span={6} style={headerMain}>Conversión</Col>
      </Row>

      <Row>
        <Col span={9}>
          <Row>
            <Col span={12} style={{ ...headerSub, borderRight: "1px solid #d9d9d9" }}>Unidad</Col>
            <Col span={12} style={headerSub}>Cantidad</Col>
          </Row>
        </Col>
        <Col span={9}>
          <Row>
            <Col span={12} style={{ ...headerSub, borderRight: "1px solid #d9d9d9" }}>Unidad</Col>
            <Col span={12} style={headerSub}>Cantidad</Col>
          </Row>
        </Col>
        <Col span={6} style={headerSub}>Factor</Col>
      </Row>

      {conversionEjemplo.map((item, index) => (
        <Row
          key={item.key}
          style={{ backgroundColor: index % 2 === 0 ? "white" : "#fafafa", transition: "background 0.2s" }}
          onMouseEnter={(e) => (e.currentTarget.style.background = "#f5faff")}
          onMouseLeave={(e) => (e.currentTarget.style.background = index % 2 === 0 ? "white" : "#fafafa")}
        >
          <Col span={9}>
            <Row>
              <Col span={12} style={{ ...cell, borderRight: "1px solid #f0f0f0" }}>{item.provUnidad}</Col>
              <Col span={12} style={cell}>{item.provCantidad}</Col>
            </Row>
          </Col>
          <Col span={9}>
            <Row>
              <Col span={12} style={{ ...cell, borderRight: "1px solid #f0f0f0" }}>{item.invUnidad}</Col>
              <Col span={12} style={cell}>{item.invCantidad}</Col>
            </Row>
          </Col>
          <Col span={6} style={cellConversion}>{item.conversion.toFixed(4)}</Col>
        </Row>
      ))}
    </Card>
  );
};

export default TablaEjemplosConversion;
